import React, { useEffect, useRef, useState } from "react";
import ButtonCompo from "../component/ButtonCompo";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AlertBox from "../component/AlertBox";
import { LinearProgress } from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../constant";
import DialogBox from "../component/DialogBox";
import SelectField from "../component/SelectField";
import attendanceIcon from "../assets/agenda.png";
import docsIcon from "../assets/checklist.png";
import compPolIcon from "../assets/file.png";
import hrDocsIcon from "../assets/hrpolicy.png";
import salaryIcon from "../assets/salary.png";
import leaveIcon from "../assets/leave.png";
import profileIcon from "../assets/user.png";
import ticketIcon from "../assets/ticket.png";
import EmployeeSearch from "../component/EmployeeSearch";
import searchEmployee from "../assets/searchEmployee.png";
import { reloadToggle } from "../store/reload.slice";
import dayjs from "dayjs";

//subcomponent for clock
const Clock = ({ time, year, month, day, setQuote, setWorkingMinutes }) => {
  const [elapseTime, setElapseTime] = useState("");

  const motivationalQuotes = [
    { minute: 0, quote: "Welcome! Let’s get started on a productive day!" },
    { minute: 30, quote: "You’re off to a great start! Keep it up!" },
    { minute: 60, quote: "Great start! Keep up the momentum!" },
    { minute: 120, quote: "You’re making progress! Stay focused!" },
    { minute: 180, quote: "Three hours done! Keep pushing forward!" },
    { minute: 240, quote: "Halfway there! You’re doing great!" },
    { minute: 300, quote: "You’ve conquered five hours! Stay strong!" },
    { minute: 360, quote: "Just three more to go! Keep the energy up!" },
    { minute: 420, quote: "You’re in the final stretch! Keep going!" },
    { minute: 480, quote: "Only one hour left! Finish strong!" },
    { minute: 540, quote: "You did it! Another productive day!" },
  ];

  // Normalize the time format (e.g., "10:33 AM" becomes ["10", "33", "AM"])
  let formatedTime = time?.replace(" ", ":").split(":");

  // Handle AM/PM conversion to 24-hour time
  if (
    formatedTime[formatedTime?.length - 1] === "PM" &&
    formatedTime[0] !== "12"
  ) {
    formatedTime[0] = (parseInt(formatedTime[0]) + 12).toString(); // Convert PM to 24-hour format
  }

  if (
    formatedTime[formatedTime?.length - 1] === "AM" &&
    formatedTime[0] === "12"
  ) {
    formatedTime[0] = "00"; // Convert 12:00 AM to 00:00 (midnight)
  } else if (
    formatedTime[formatedTime?.length - 1] === "AM" &&
    formatedTime[0] !== "12"
  ) {
    formatedTime[0] = formatedTime[0];
  }

  // Set up the effect to calculate elapsed time from the specific input time
  useEffect(() => {
    // Construct the formatted date string for the starting point (time from input + today's date)
    const formattedDate = `${year?.toString()?.padStart(2, 0)}-${month
      ?.toString()
      ?.padStart(2, 0)}-${day?.toString()?.padStart(2, 0)}T${formatedTime[0]
      .toString()
      .padStart(2, "0")}:${formatedTime[1].toString().padStart(2, "0")}:00`;

    // Get the start time as local time (no 'Z' for UTC)
    const startTime = new Date(formattedDate).getTime();

    const intervalId = setInterval(() => {
      const currentTime = Date.now();
      const timeDifference = currentTime - startTime;

      // console.log(formattedDate);

      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      // console.log(hours)
      // console.log(minutes)

      // Format time with leading zeros if necessary
      const formattedTime = `${
        hours.toString().padStart(2, "0") === "NaN"
          ? "--"
          : hours.toString().padStart(2, "0")
      }:${
        minutes.toString().padStart(2, "0") === "NaN"
          ? "--"
          : minutes.toString().padStart(2, "0")
      }:${
        seconds.toString().padStart(2, "0") === "NaN"
          ? "--"
          : seconds.toString().padStart(2, "0")
      }`;

      // console.log(hours * 60 + minutes);
      const totalMinutes = hours * 60 + minutes;

      const currentQuote =
        totalMinutes > 540
          ? "Doing overtime? Good but finish ASAP and take some rest"
          : motivationalQuotes
              .slice() // Clone the array to prevent mutations
              .reverse() // Reverse to get the latest matching quote
              .find((q) => totalMinutes >= q.minute)?.quote ||
            "Keep going! Stay motivated!";
      setQuote(currentQuote);

      setElapseTime(formattedTime);
      setWorkingMinutes(totalMinutes);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [formatedTime]);

  return (
    <div>
      <h1 className="text-[30px]">{elapseTime}</h1>
      <p> </p>
    </div>
  );
};

function OptionCard({ icon, title, link }) {
  return (
    <Link to={link}>
      <section className="flex justify-center items-center flex-col border w-full p-3 rounded-xl hover:bg-slate-50 shadow-lg">
        <section className="w-[5rem] h-[5rem]">
          <img src={icon} alt="" className="w-ful h-full object-contain" />
        </section>
        <h2 className="mt-3 text-center font-medium text-slate-700">{title}</h2>
      </section>
    </Link>
  );
}

function EmployeeDashboard() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [attendanceData, setAttendanceData] = useState({});
  const [location, setLocation] = useState("");
  const [place, setPlace] = useState("");
  const [reload, setReload] = useState(false);
  const [quote, setQuote] = useState("");
  const [workingMinutes, setWorkingMinutes] = useState(0);
  const firstDiv = 3 * 60;
  const secondDiv = 6 * 60;

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  console.log(isEmployee);

  //redirect to employee onboarding form if employee is here for the first time
  useEffect(() => {
    if (employeeData !== null && employeeData?.isJoined === false) {
      navigate("/employee/onboarding/form");
    }
  }, [employeeData]);

  useEffect(() => {
    if (employeeData !== null && employeeData?.isActive === false) {
      navigate("/employee/signin");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const adminRole = useSelector((state) => state.adminRole?.adminRoleNav);
  const [allNotifications, setAllNotifications] = useState([]);
  const dispatch = useDispatch();

  // fetch attendance
  async function getAttendance() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/attendance/today/get`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data);
      setAttendanceData(res.data?.data);
    } catch (error) {
      console.log(error);
      // setOpen(true);
      // setSuccess(false);
      // setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getAttendance();
  }, [reload]);

  // employee clock in
  async function clockIn() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/clock/in`,
        method: "post",
        withCredentials: true,
        data: {
          location: location,
          place: place,
        },
      });
      console.log(res.data?.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Clocked in successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  // employee clock out
  async function clockOut() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/clock/out`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Clocked out successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  // place dropdown
  const placeArray = [
    {
      title: "Office",
      value: "Office",
    },
    {
      title: "Home",
      value: "Home",
    },
  ];

  const optionsArray = [
    {
      icon: attendanceIcon,
      title: "Attendance",
      link: "/employee/attendance",
    },
    {
      icon: hrDocsIcon,
      title: "My Docs",
      link: "/employee/my-documents",
    },
    {
      icon: leaveIcon,
      title: "Leave & Holidays",
      link: "/employee/leave",
    },
    {
      icon: salaryIcon,
      title: "Salary & Payslip",
      link: "/employee/salary",
    },
    {
      icon: compPolIcon,
      title: "Company Policies",
      link: "/employee/hr/policies",
    },
    {
      icon: ticketIcon,
      title: "Ticket",
      link: "/employee/tickets",
    },
    {
      icon: profileIcon,
      title: "My Profile",
      link: "/my-profile",
    },
  ];

  const [unopenedNotifications, setUnopenedNotofications] = useState(0);
  const [notificationData, setNotificationData] = useState([]);

  //fetch all notifications
  async function getNotifications() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/notifications`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      let rawData = res.data?.data;
      let totalUnopenedNotification = 0;
      rawData?.map((e) => {
        if (e?.isOpen === false) {
          totalUnopenedNotification = totalUnopenedNotification + 1;
        }
      });
      setUnopenedNotofications(totalUnopenedNotification);
      let reversedArray = [];
      let notificationLen = rawData.length;

      // reversing the array to show latest data to the top
      for (let index = notificationLen - 1; index >= 0; index--) {
        // saving index value because the operation will fail in backend if the index value is inappropiate
        let newObj = { ...rawData[index], index: index };
        reversedArray.push(newObj);
      }
      // console.log(reversedArray);
      setNotificationData(reversedArray);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  // update notification status
  async function updateNotificationStatus(data, index) {
    try {
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/update/notifications`,
        method: "post",
        data: {
          data: data,
          index: index,
        },
        withCredentials: true,
      });
      setReload((prev) => !prev);
      dispatch(reloadToggle());
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
    }
  }

  console.log(employeeData);

  useEffect(() => {
    getNotifications();
  }, [reload]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLocation(
          `lat-${position.coords.latitude}&lng-${position.coords.longitude}`
        );
      });
    }
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex flex-col justify-center items-center py-5">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] flex flex-col justify-center gap-5">
          {attendanceData?.actualLogoutTimeStamp === undefined ? (
            attendanceData?.actualLoginTimeStamp !== undefined ? (
              <h1 className="text-center text-[30px] font-semibold text-slate-700">
                {quote}
              </h1>
            ) : (
              <h1 className="text-center text-[30px] font-semibold text-slate-700">
                Dashboard
              </h1>
            )
          ) : (
            <h1 className="text-center text-[30px] font-semibold text-slate-700">
              Go and take some rest
            </h1>
          )}
          {employeeData?.projectData?.name && employeeData?.projectData?.deadline && (
            <div className="">
              <section className="flex flex-col justify-center items-center">
                <p className="text-slate-500 text-[15px]">
                  Project:{" "}
                  <span className="text-blue-600 font-medium">
                    {employeeData?.projectData?.name}
                  </span>
                </p>
                <p className="text-[30px] text-blue-500 font-semibold">
                  {dayjs(employeeData?.projectData?.deadline).diff(
                    new Date(),
                    "day"
                  ) > 1
                    ? `${dayjs(employeeData?.projectData?.deadline).diff(
                        new Date(),
                        "day"
                      )} days`
                    : `${dayjs(employeeData?.projectData?.deadline).diff(
                        new Date(),
                        "day"
                      )} day`}{" "}
                  left
                </p>
              </section>
            </div>
          )}
          <div className="flex flex-col md:flex-row justify-center items-start gap-5 mt-5">
            <div className="w-full">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[3rem]">
                {optionsArray.map((opt, i) => (
                  <OptionCard
                    icon={opt.icon}
                    title={opt.title}
                    link={opt.link}
                    key={i}
                  />
                ))}
                <EmployeeSearch
                  trigger={
                    <section className="flex justify-center items-center flex-col border w-full p-3 rounded-xl hover:bg-slate-50 shadow-lg">
                      <section className="w-[5rem] h-[5rem]">
                        <img
                          src={searchEmployee}
                          alt=""
                          className="w-full h-full object-contain"
                        />
                      </section>
                      <h2 className="mt-3 text-center font-medium text-slate-700">
                        Search Employees
                      </h2>
                    </section>
                  }
                />
              </div>
            </div>
            <div className="w-[90vw] md:w-[30rem] border rounded-[10px] shadow-md">
              <section className="px-5 py-3 bg-blue-500 rounded-t-[10px]">
                <h1 className="text-white font-medium">Clock In & Clock Out</h1>
              </section>
              <div className="w-full px-5 py-3">
                <div className="w-full">
                  <p className="text-[13px] font-normal text-slate-500">
                    {new Date(
                      attendanceData?.year,
                      attendanceData?.month,
                      attendanceData?.dayOfMonth
                    ).toDateString() === "Invalid Date"
                      ? new Date().toLocaleDateString()
                      : new Date(
                          attendanceData?.year,
                          attendanceData?.month,
                          attendanceData?.dayOfMonth
                        ).toDateString()}
                  </p>
                  {attendanceData?.actualLogoutTimeStamp === undefined ? (
                    attendanceData?.actualLoginTimeStamp !== undefined ? (
                      <Clock
                        time={attendanceData?.actualLoginTimeStamp || "0:00 AM"}
                        day={attendanceData?.dayOfMonth}
                        month={Number(attendanceData?.month) + 1}
                        year={attendanceData?.year}
                        setQuote={setQuote}
                        setWorkingMinutes={setWorkingMinutes}
                      />
                    ) : (
                      <p className="text-[30px]">--:--</p>
                    )
                  ) : (
                    <p className="text-[30px]">--:--</p>
                  )}
                </div>
                <div className="mt-5 w-full grid grid-cols-2 gap-5">
                  <section>
                    <p className="text-[15px] font-medium">
                      Expected Login Time
                    </p>
                    <span className="text-[15px] text-slate-500">
                      {attendanceData?.expectedLoginTimeStamp || "--:--"}
                    </span>
                  </section>
                  <section>
                    <p className="text-[15px] font-medium">
                      Expected Logout Time
                    </p>
                    <span className="text-[15px] text-slate-500">
                      {attendanceData?.expectedLogoutTimeStamp || "--:--"}
                    </span>
                  </section>
                  <section>
                    <p className="text-[15px] font-medium">Your Login Time</p>
                    <span className="text-[15px] text-slate-500">
                      {attendanceData?.actualLoginTimeStamp || "--:--"}
                    </span>
                  </section>
                  <section>
                    <p className="text-[15px] font-medium">Your Logout Time</p>
                    <span className="text-[15px] text-slate-500">
                      {attendanceData?.actualLogoutTimeStamp || "--:--"}
                    </span>
                  </section>
                </div>
                <div className="mt-5">
                  {attendanceData?.actualLoginTimeStamp !== undefined ? (
                    attendanceData?.actualLogoutTimeStamp === undefined ? (
                      <ButtonCompo
                        variant={"contained"}
                        className="!w-full"
                        color={"error"}
                        onClick={clockOut}
                      >
                        Clock out
                      </ButtonCompo>
                    ) : (
                      ""
                    )
                  ) : (
                    <DialogBox
                      trigger={
                        <ButtonCompo variant={"contained"} className="!w-full">
                          Clock In
                        </ButtonCompo>
                      }
                      title="Clock In"
                      actionButton={
                        <ButtonCompo className="!w-full" onClick={clockIn}>
                          Clock In
                        </ButtonCompo>
                      }
                      closeActionButton="Cancel"
                    >
                      <SelectField
                        label={"Place"}
                        valueArray={placeArray}
                        setValue={(e) => setPlace(e?.target?.value)}
                      />
                    </DialogBox>
                  )}
                  {attendanceData?.actualLoginTimeStamp !== undefined &&
                    attendanceData?.actualLogoutTimeStamp === undefined && (
                      <section className="mt-1">
                        <p>
                          {workingMinutes > firstDiv ? (
                            workingMinutes > secondDiv ? (
                              ""
                            ) : (
                              <span className="text-[14px] text-slate-700">
                                If you clock out now, you will be charged by{" "}
                                <span className="font-medium">
                                  half day leave.
                                </span>
                              </span>
                            )
                          ) : (
                            <span className="text-[14px] text-slate-700">
                              If you clock out now, you will be charged by{" "}
                              <span className="font-medium">
                                full day leave.
                              </span>
                            </span>
                          )}
                        </p>
                      </section>
                    )}
                </div>
              </div>
            </div>
          </div>
          {employeeData?.adminId && employeeData?.admin && (
            <div className="w-full flex justify-between gap-5">
              <div className="w-[40rem] shadow-xl">
                <section className="px-5 py-3 bg-blue-500 text-white font-medium">
                  {employeeData?.admin?.role === "headHr"
                    ? "Human Resource"
                    : employeeData?.admin?.role === "hrRecruiter"
                    ? "Recruiter"
                    : employeeData?.admin?.role === "manager"
                    ? "Manager"
                    : employeeData?.admin?.role === "facilityTeam"
                    ? "Facility"
                    : employeeData?.admin?.role === "itHelpDesk"
                    ? "IT Helpdesk"
                    : "Custom"}{" "}
                  Task
                </section>
                {Array.isArray(adminRole) && adminRole.length > 0 ? (
                  <div
                    className="h-[20rem] overflow-auto"
                    style={{ scrollbarWidth: "none" }}
                  >
                    {adminRole.map((role, i) => (
                      <Link to={role?.link}>
                        <section className="flex items-center gap-2 px-5 py-5 border-b-[1px] text-slate-700 hover:bg-blue-50">
                          <section className="text-[20px]">{role.icon}</section>
                          {role.header}
                        </section>
                      </Link>
                    ))}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="w-full shadow-xl">
                <section className="px-5 py-3 bg-blue-500 text-white font-medium">
                  Notifications
                </section>
                <div
                  className="w-full space-y-2 h-[20rem] overflow-auto"
                  style={{ scrollbarWidth: "none" }}
                >
                  {notificationData?.map((e, i) => (
                    <NavLink to={e?.link} key={i}>
                      <section
                        className={`${
                          e?.isOpen === true ? "" : "bg-sky-100/70"
                        } py-3 px-3 cursor-pointer hover:bg-slate-100`}
                        onClick={() => updateNotificationStatus(e, e?.index)}
                      >
                        <p className="font-medium">
                          {e?.message}{" "}
                          {e?.isOpen === false ? (
                            <span className="text-[14px] bg-sky-500 text-white px-3 py-1 rounded-full font-medium ml-2">
                              Action required
                            </span>
                          ) : (
                            ""
                          )}
                        </p>
                        <p className="flex w-full justify-between items-center mt-2 text-[15px] text-slate-500">
                          {e?.date}
                        </p>
                      </section>
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EmployeeDashboard;
